import { SEARCH_RESULTS_TO_SHOW } from '../../../../../../config/constants';
import { TSearchResultFull } from '../../../../../../pages/services/[planSeoSlug]/api/types';

export const findSearchDocumentWithName = (
  searchItems: TSearchResultFull | undefined,
  name: string
) => {
  return searchItems?.hits?.find((el) => el.document.name === name);
};

export const getOptionsForSelect = (
  searchItems: TSearchResultFull | undefined
) => {
  if (!searchItems) return [];
  return searchItems.hits
    ?.map(({ document }) => ({
      value: document.seo_slug,
      label: document.name,
    }))
    .slice(0, SEARCH_RESULTS_TO_SHOW);
};
